import React, {useRef, useState} from "react";
import {Col, ControlLabel, FormControl, FormGroup, Row} from "react-bootstrap";
import FormControlLanguage from "../../UI/FormControlLanguage";

export default ({member, onChange, onChangePhoto}) => {
    const [id, setId] = useState(member.id);
    const [fullnameRu, setFullnameRu] = useState(member.fullnameRu || '');
    const [fullnameEn, setFullnameEn] = useState(member.fullnameEn || '');
    const [descriptionRu, setDescriptionRu] = useState(member.descriptionRu);
    const [descriptionEn, setDescriptionEn] = useState(member.descriptionEn);
    const [externalId, setExternalId] = useState(member.externalId);
    const [photoUrl, setPhotoUrl] = useState(member.photo);
    const photoInputRef = useRef(null);

    const handleSave = async () => {
        const data = {};

        if (member.fullnameRu !== fullnameRu) data.fullnameRu = fullnameRu;
        if (member.fullnameEn !== fullnameEn) data.fullnameEn = fullnameEn;
        if (member.descriptionRu !== descriptionRu) data.descriptionRu = descriptionRu;
        if (member.descriptionEn !== descriptionEn) data.descriptionEn = descriptionEn;
        if (member.externalId !== externalId) data.externalId = externalId;

        if (Object.keys(data).length === 0) {
            return;
        }

        try {
            const response = await onChange(id, data);
            console.log('>> save', response);
            setId(response.id);
            Object.assign(member, response);
        } catch(e) {
            console.error(e);
        }
    }

    const handleChangePhoto = async () => {
        if (photoInputRef.current?.files.length === 0) {
            return;
        }

        try {
            const {photo} = await onChangePhoto(id, photoInputRef.current.files[0]);
            setPhotoUrl(photo + '?t=' + Math.random());
        } catch (e) {}
        photoInputRef.current.value = '';
    }

    return (
        <>
            <Row>
                <Col md={6}>
                    <FormGroup>
                        <ControlLabel>ID</ControlLabel>
                        <FormControl
                            type="text"
                            value={id || ''}
                            readOnly
                            onChange={(e) => setId(e.target.value)}
                        />
                    </FormGroup>
                </Col>
                <Col md={6}>
                    <FormGroup>
                        <ControlLabel>Внешний ID</ControlLabel>
                        <FormControl
                            type="text"
                            value={externalId}
                            onChange={(e) => setExternalId(e.target.value)}
                        />
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col md={3}>
                    <FormGroup>
                        <ControlLabel>Фото</ControlLabel>
                        <p>
                            <img
                                src={photoUrl || '/player/images/avatar.svg'}
                                onClick={() => photoInputRef.current.click()}
                                alt={''}
                                style={{
                                    maxWidth: '100%',
                                    minWidth: 120,
                                    cursor: 'pointer',
                                    border: 'solid 1px rgba(0, 0, 0, .2)',
                                    borderRadius: 4,
                                }}
                            />
                        </p>
                        <FormControl
                            type="file"
                            inputRef={ref => photoInputRef.current = ref}
                            onChange={handleChangePhoto}
                            style={{display: 'none'}}
                        />
                    </FormGroup>
                </Col>
                <Col md={9}>
                    <FormGroup>
                        <ControlLabel>ФИО</ControlLabel>
                        <FormControlLanguage
                            type="text"
                            values={{
                                ru: fullnameRu,
                                en: fullnameEn,
                            }}
                            onChange={{
                                ru: (e) => setFullnameRu(e.target.value),
                                en: (e) => setFullnameEn(e.target.value),
                            }}
                            onBlur={handleSave}
                        />
                    </FormGroup>
                    <FormGroup>
                        <ControlLabel>Описание</ControlLabel>
                        <FormControlLanguage
                            componentClass="textarea"
                            rows={4}
                            type="text"
                            values={{
                                ru: descriptionRu,
                                en: descriptionEn,
                            }}
                            onChange={{
                                ru: (e) => setDescriptionRu(e.target.value),
                                en: (e) => setDescriptionEn(e.target.value),
                            }}
                            onBlur={handleSave}
                        />
                    </FormGroup>
                </Col>
            </Row>
        </>
    );
}
